import React from 'react'
import { Datagrid, DateField, TextField, useResourceContext } from 'react-admin'
import { getGeoLang } from 'services/geo-management'
import { optionsDate } from 'services/utils/date'
import DeleteAndExportBulk from 'ui-shared/BulkActionGroups/DeleteAndExportBulk'
import BriefAndSupplyStatusField from 'ui-shared/FormComponents/BriefAndSupplyStatusField'
import KFilters from 'ui-shared/KFilters'
import KPagination from 'ui-shared/KPagination'
import KList from 'ui-shared/KWrappers/KList'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import { BaseListProps } from 'ui-shared/WrappedInputs/CatalogItemBaseList'

const EventList: React.FC<BaseListProps> = (props) => {
  const resource = useResourceContext()

  return (
    <SectionWrapper>
      <KList
        {...props}
        exporter={false}
        pagination={<KPagination />}
        perPage={40}
        filters={<KFilters />}
      >
        <Datagrid rowClick="edit" bulkActionButtons={<DeleteAndExportBulk />}>
          <TextField label="form.fields.event" source="id" sortable={false} />
          <TextField label="form.fields.name" source="name" sortable={false} />
          <TextField
            label="form.fields.name"
            source="customerInfo.name"
            sortable={false}
          />
          <TextField
            label="form.fields.email"
            source="customerInfo.email"
            sortable={false}
          />
          <TextField
            label="form.fields.purchasedServices"
            source="purchasedServices"
            sortable={false}
          />
          <DateField
            label="form.fields.startDate"
            source="startDate"
            options={optionsDate}
            locales={getGeoLang()}
          />
          <DateField
            label="Creation Date"
            source="createdAt"
            options={optionsDate}
            locales={getGeoLang()}
          />

          {resource === 'events' && (
            <BriefAndSupplyStatusField
              source="briefStatus"
              label="form.fields.briefStatus"
            />
          )}
          {resource === 'events' && (
            <BriefAndSupplyStatusField
              source="supplierStatus"
              label="form.fields.supplierStatus"
            />
          )}
          <TextField label="Supplier Message" source="supplierMessagesStatus" />
        </Datagrid>
      </KList>
    </SectionWrapper>
  )
}
export default EventList
